import React from "react";
import CompleteSTable from "./CompleteSTable";

const CompleteSTableProps = ({
  studentList,
  isAutoEval = false,
  onOfflineClick,
}) => {
  return (
    <>
      {studentList?.length > 0 &&
        studentList.map((student, index) => (
          <CompleteSTable
            key={index}
            student={student}
            isAutoEval={isAutoEval}
            onOfflineClick={onOfflineClick}
          />
        ))}
    </>
  );
};

export default CompleteSTableProps;
